import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import {
  CategoryTotalContainer,
  DescriptionBar,
  ValueBar,
  NumberCurrency,
  Spacer
} from './css';
import { formatCurrency } from '../../../utils/currencyFormatter';

const FmMicrosoftLicensingTotal = ({ price }) => {
  return (
    <>
      <Spacer />
      <CategoryTotalContainer>
        <DescriptionBar>Monthly Microsoft Licensing Total</DescriptionBar>
        <ValueBar pos="right">
          Total Price: <NumberCurrency>{formatCurrency(price)}</NumberCurrency>
        </ValueBar>
      </CategoryTotalContainer>
    </>
  );
};

FmMicrosoftLicensingTotal.propTypes = {
  price: PropTypes.number.isRequired
};

export default FmMicrosoftLicensingTotal;
